import { takeLatest } from "redux-saga/effects"
import { FETCH_USER_REQUEST, REGISTER_USER } from "../actions/user"

import { FETCH_OWNERS } from "../actions/owners"
import { FETCH_OWNER, CREATE_OWNER, UPDATE_OWNER, DELETE_OWNER  } from "../actions/owner"
import { USER_LOGIN, USER_LOGOUT, USER_LOGGED_OUT , USER_LOGGED_IN} from "../actions/auth"

import { FETCH_PRODUCTS } from "../actions/products"
import { FETCH_PRODUCT, SEND_MESSAGE  } from "../actions/product"

import { FETCH_NEWSLIST } from "../actions/newsList"
import { FETCH_NEWS } from "../actions/news"

import { FETCH_ACCOUNT, UPDATE_NEWSTATUS, UPDATE_ACCOUNT, UPDATE_PASSWORD } from '../actions/account'

import { FETCH_TITLE } from '../actions/title'

import { FETCH_CATEGORIES_BOARD } from '../actions/categoryBoard'
import { FETCH_BOARDS } from '../actions/boards'
import { FETCH_BOARD, CREATE_BOARD, UPDATE_BOARD, DELETE_BOARD, CREATE_COMMENT, DELETE_COMMENT } from '../actions/board'

import { SEND_CONTACT } from '../actions/contact'

import { login, logout, setLogin, resetLogin } from "./auth"
import { fetchUserData, register } from "./user"
import { fetchOwner, createOwner, updateOwner, deleteOwner } from "./owner"
import { fetchOwners } from "./owners"

import { fetchProduct, sendMessage } from "./product"
import { fetchProducts } from "./products"

import { fetchNews } from "./news"
import { fetchNewsList } from "./newsList"

import { fetchAccount, updateNewStatus, updateAccount, updatePassword } from './account'

import { fetchTitle } from './title'

import { fetchCategoriesBoard } from './categoryBoard'
import { fetchBoards } from './boards'
import { fetchBoardDetail, createBoard, updateBoard, deleteBoard, createComment, deleteComment } from './board'

import { sendContactUs } from './contact'


export default function* sagas() {
    yield takeLatest(USER_LOGIN, login)
    yield takeLatest(USER_LOGOUT, logout)
    yield takeLatest(USER_LOGGED_OUT, resetLogin)
    yield takeLatest(USER_LOGGED_IN, setLogin)

    yield takeLatest(FETCH_USER_REQUEST, fetchUserData)
    yield takeLatest(REGISTER_USER, register)

    yield takeLatest(FETCH_OWNERS, fetchOwners)
    yield takeLatest(FETCH_OWNER, fetchOwner)
    yield takeLatest(CREATE_OWNER, createOwner)
    yield takeLatest(UPDATE_OWNER, updateOwner)
    yield takeLatest(DELETE_OWNER, deleteOwner)

    yield takeLatest(FETCH_PRODUCTS, fetchProducts)
    yield takeLatest(FETCH_PRODUCT, fetchProduct)
    yield takeLatest(SEND_MESSAGE, sendMessage)

    yield takeLatest(FETCH_NEWSLIST, fetchNewsList)
    yield takeLatest(FETCH_NEWS, fetchNews)

    yield takeLatest(FETCH_ACCOUNT, fetchAccount)
    yield takeLatest(UPDATE_NEWSTATUS, updateNewStatus)
    yield takeLatest(UPDATE_ACCOUNT, updateAccount)
    yield takeLatest(UPDATE_PASSWORD, updatePassword)

    yield takeLatest(FETCH_TITLE, fetchTitle)

    yield takeLatest(FETCH_CATEGORIES_BOARD, fetchCategoriesBoard)
    yield takeLatest(FETCH_BOARDS, fetchBoards)
    yield takeLatest(FETCH_BOARD, fetchBoardDetail)
    yield takeLatest(CREATE_BOARD, createBoard)
    yield takeLatest(UPDATE_BOARD, updateBoard)
    yield takeLatest(DELETE_BOARD, deleteBoard)
    yield takeLatest(CREATE_COMMENT, createComment)
    yield takeLatest(DELETE_COMMENT, deleteComment)

    yield takeLatest(SEND_CONTACT, sendContactUs)
}